import { useMutation, useQueryClient } from "@tanstack/react-query";
import { WorkOrderInput } from "../type/WorkOrder";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { GET_WORK_ORDERS_FETCH_KEY } from "./useGetWorkOrder";

export const createWorkOrder = async (
  newWorkOrder: Partial<WorkOrderInput>,
): Promise<WorkOrderInput> => {
  const response = await fetcher.post(`${API.GESLUB}/workOrders`, newWorkOrder);
  return response.data;
};

export const useCreateWorkOrder = () => {
  const queryClient = useQueryClient();

  return useMutation<WorkOrderInput, Error, Partial<WorkOrderInput>>({
    mutationFn: createWorkOrder,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_WORK_ORDERS_FETCH_KEY],
      });
    },
    onError: (error) => {
      console.error("Error creating work order:", error);
    },
  });
};
